import Component from 'D:/小小程序员/项目/medical-management/OPO-uni/node_modules/@dcloudio/uni-ui/lib/uni-drawer/uni-drawer.vue'
wx.createComponent(Component)